import React, { useEffect, useState, useMemo } from "react";
import Article from "./article";

const API = (process.env.REACT_APP_API_BASE_URL || "http://localhost:7000").replace(/\/$/, "");
const WEBSITE_ID = process.env.REACT_APP_WEBSITE_ID;

function fmtDate(d) {
  if (!d) return "";
  const date = new Date(d);
  return isNaN(date) ? "" : date.toISOString(); // keep ISO; UI formats inside ViewMore
}

export default function ArticleLoader({ sectionSlug = "nyheter", itemSlug, fallbackTitle }) {
  const [item, setItem] = useState(null);
  const [allNewsItems, setAllNewsItems] = useState([]);
  const [err, setErr] = useState("");

  useEffect(() => {
    (async () => {
      try {
        // Resolve section to get its _id
        const secRes = await fetch(
          `${API}/api/public/site-contents/resolve/${WEBSITE_ID}/${sectionSlug}`
        );
        if (!secRes.ok) throw new Error("Kunde inte hitta nyhetssektionen");
        const section = await secRes.json(); // {_id, name, slug, websiteId, ...}

        // Fetch the current item with full content
        const detRes = await fetch(
          `${API}/api/public/content-items/resolve-by-slug/${WEBSITE_ID}/${sectionSlug}/${itemSlug}`
        );
        if (!detRes.ok) throw new Error("Kunde inte hämta artikelns innehåll");
        const det = await detRes.json(); // { sectionId, item }
        setItem(det.item);

        // Fetch all items in the section (list; no heavy content)
        const listRes = await fetch(
          `${API}/api/public/content-items/by-content/${section._id}`
        );
        if (listRes.ok) {
          const list = await listRes.json();
          setAllNewsItems(Array.isArray(list) ? list : []);
        } else {
          setAllNewsItems([]);
        }
      } catch (e) {
        setErr(e.message || "Fel vid hämtning av artikel");
      }
    })();
  }, [sectionSlug, itemSlug]);

  // Build "view more" = same section, exclude current slug, top 3 by updatedAt/createdAt desc
  const viewMoreArticles = useMemo(() => {
    const currentSlug = itemSlug;
    const sorted = [...allNewsItems].sort((a, b) => {
      const ad = new Date(a.updatedAt || a.createdAt || 0).getTime();
      const bd = new Date(b.updatedAt || b.createdAt || 0).getTime();
      return bd - ad;
    });
    return sorted
      .filter((x) => x.link !== currentSlug)
      .slice(0, 3)
      .map((x) => ({
        title: x.name,
        slug: x.link,
        updatedAt: fmtDate(x.updatedAt),
        createdAt: fmtDate(x.createdAt),
      }));
  }, [allNewsItems, itemSlug]);

  if (err) return <div className="p-8 text-red-600">{err}</div>;
  if (!item) return <div className="p-8">Laddar in…</div>;

  return (
    <Article
      title={item.name || fallbackTitle}
      content={item.content || ""}
      viewMoreArticles={viewMoreArticles}
      updatedAt={item.updatedAt}
      createdAt={item.createdAt}
    />
  );
}
